module.exports = __webpack_public_path__ + "img/main-h5.d274a4ed.png";